import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

const TRANSFORM_PATHS_0 = [
  { path: 'timeSlotsConfiguration.createdDate' },
  { path: 'timeSlotsConfiguration.updatedDate' },
];

function resolveWixBookingsProvisionerV1ProvisionerServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {};

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_bookings_bookings-provisioner';

/**
 * Sets up the [Wix Bookings platform](https://dev.wix.com/docs/api-reference/business-solutions/bookings/bookings-platform/introduction) for an app.
 *
 * Use this method to initialize your app's booking infrastructure.
 * This creates a time slots configuration that controls how available time slots
 * are displayed to customers.
 *
 * The app must be installed on the site before calling this method.
 *
 * This method is idempotent. Calling it multiple times for the same app
 * has no effect if the configuration already exists.
 */
export function provisionBookingsPlatform(
  payload: object
): RequestOptionsFactory<any> {
  function __provisionBookingsPlatform({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: TRANSFORM_PATHS_0,
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.bookings.provisioner.v1.apps_cloned',
      method: 'POST' as any,
      methodFqn:
        'wix.bookings.provisioner.v1.ProvisionerService.ProvisionBookingsPlatform',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixBookingsProvisionerV1ProvisionerServiceUrl({
        protoPath: '/v1/provisioner/provision-bookings-platform',
        data: serializedData,
        host,
      }),
      data: serializedData,
    };

    return metadata;
  }

  return __provisionBookingsPlatform;
}
